import React from "react";
import { FaArrowRight, FaDesktop, FaMobileScreen, FaCloud, FaGear } from "react-icons/fa6";
import { Container } from "../home/ui";

const services = [
  {
    icon: FaDesktop,
    title: "Web Application Development",
    text: "Modern, scalable web applications using latest technologies.",
    href: "/service/website-design-development-solutions",
    card: "from-[#EEF4FF] to-[#F6F9FF]",
    tone: "text-[#1E6BFF]",
  },
  {
    icon: FaMobileScreen,
    title: "Mobile App Development",
    text: "iOS & Android applications with seamless experience.",
    href: "/service/mobile-app-design-development-solutions",
    card: "from-[#F4EEFF] to-[#FAF7FF]",
    tone: "text-[#7C3AED]",
  },
  {
    icon: FaCloud,
    title: "Cloud Solutions",
    text: "Scalable and secure cloud infrastructure and deployment.",
    href: "/contact-us",
    card: "from-[#EBF8F0] to-[#F5FCF8]",
    tone: "text-[#16A34A]",
  },
  {
    icon: FaGear,
    title: "Enterprise Solutions",
    text: "Custom software for large scale businesses.",
    href: "/contact-us",
    card: "from-[#FFF5E6] to-[#FFFAF2]",
    tone: "text-[#F59E0B]",
  },
];

const SoftServices = () => (
  <section className="bg-white py-[44px] lg:py-[60px]">
    <Container className="max-w-[1320px]">
      <div className="grid items-center gap-[32px] lg:grid-cols-[minmax(0,0.78fr)_minmax(0,1.22fr)] lg:gap-[40px]">
        <div>
          <span className="inline-block rounded-full bg-[#E6EEFF] px-[14px] py-[5px] text-[12px] font-semibold uppercase tracking-[0.04em] text-[#1E4DFF]">
            Our Services
          </span>
          <h2 className="mt-[14px] text-[28px] font-extrabold leading-[1.2] tracking-tight text-[#0B0D2C] sm:text-[34px] xl:text-[clamp(28px,2.2vw,38px)]">
            Comprehensive Software
            <br />
            Development Services
          </h2>
          <p className="mt-[14px] max-w-[460px] text-[15px] leading-[1.6] text-slate-600 sm:text-[16px]">
            We offer end-to-end software development services to help businesses innovate, scale, and succeed in the digital
            world.
          </p>
        </div>

        <div className="grid auto-rows-fr gap-[14px] sm:grid-cols-2 xl:grid-cols-4">
          {services.map((s) => (
            <a
              key={s.title}
              href={s.href}
              className={`group flex h-full min-w-0 flex-col rounded-[16px] bg-gradient-to-b p-[20px] shadow-[0_10px_28px_-20px_rgba(40,60,140,0.3)] transition hover:-translate-y-1 ${s.card}`}
            >
              <s.icon className={`text-[24px] ${s.tone}`} />
              <h3 className="mt-[16px] text-[15px] font-bold leading-[1.3] text-[#0B0D2C]">{s.title}</h3>
              <p className="mt-[6px] flex-1 text-[13.5px] leading-[1.5] text-slate-600">{s.text}</p>
              <span className={`mt-[16px] inline-flex items-center gap-[8px] text-[14px] font-medium ${s.tone}`}>
                Learn More
                <FaArrowRight className="text-[12px] transition group-hover:translate-x-1" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </Container>
  </section>
);

export default SoftServices;
